<template>
  <div class="align-items-center justify-content-center activityPopup">
    <div class="popup-container">
      <transition name="bounce">
        <div v-show="open" class="activity-button box" :class="[name]">
          <div class="info-window">
            <button class="btn close-button" v-on:click="closeClicked"/>

            <div class="header"></div>

            <div class="info-content">

              <div class="icon" :class="[name]"></div>
              <p class="title">BEWEEG TUSSENDOOR</p>
              <p class="description">Kies of je een willekeurige 'Beweeg Tussendoor' opdracht wil starten of een code
                van het 'Beweeg Tussendoor' kaartspel wil ingeven.</p>
            </div>
            <div class="footer"></div>

            <div class="button-row">
              <WhiteOutlineButton :buttonText="'OPDRACHT KIEZEN'" :stretch-to-fill="false" :no-resize-text="true"
                                  v-on:clicked="openActivityListClicked"></WhiteOutlineButton>

              <WhiteOutlineButton :buttonText="'WILLEKEURIGE OPDRACHT'" :stretch-to-fill="false" :no-resize-text="true"
                                  v-on:clicked="randomActivityButtonClicked"></WhiteOutlineButton>

              <WhiteOutlineButton :buttonText="'CODE INGEVEN'" :stretch-to-fill="false" :no-resize-text="true"
                                  v-on:clicked="codeClicked"></WhiteOutlineButton>
            </div>

          </div>

        </div>
      </transition>

    </div>
  </div>


</template>

<script>
  import {BuddyApi} from "sandpiper_api";
  import log from "@/utils/logger";
  import WhiteOutlineButton from "@/components/StudentPlatform/WhiteOutlineButton";
  import {ActivityType} from "@/enums/ActivityType";

  export default {
    name: "ImpulsePopup",
    components: {WhiteOutlineButton},
    props: {
      name: String,
      open: Boolean,
      buddyId: Number,
    },
    inject: ["doApiRequest"],
    data() {
      return {
        show: this.open,
      }
    },
    computed: {},
    mixins: [],
    methods: {

      closeClicked() {
        this.$emit("closeClicked");
      },
      async randomActivityButtonClicked() {
        let quest = await this.fetchRandomQuest();
        if(quest !== null) {
          this.$emit("randomActivityClicked", quest.id, true);
        }
      },
      async openActivityListClicked() {
        this.$emit("openActivityListClicked");
      },
      codeClicked() {
        this.$emit("codeClicked");
      },

      async fetchRandomQuest() {
        try {
          this.fetchingActivity = true;
          log.info("fetching random quest")
          const response = await this.doApiRequest(() => new BuddyApi().getRandomQuestForBuddy(this.buddyId, {questType: ActivityType.IMPULSE}));

          log.info("Fetch activity response: %o", response);
          return response;
        } catch (e) {
          log.error(e);
          return null;
          // TODO - handle exception
        } finally {
          this.fetchingActivity = false;
        }
      },

    },
    mounted() {

    },
    created() {
    },
  }


</script>

<style lang="scss" scoped>

  .activityPopup {
    width: 100vw;
    height: 100vh;
    position: absolute;
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 9999;
    top: 0;
    left: 0;
    display: flex;

    .popup-container {
      width: min(90vw, 90vh);
      height: min(80vw, 80vh);
    }

  }

  .activity-button {
    margin-bottom: 10px;
    background-repeat: no-repeat;
    background-position: center;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 10%;
    position: relative;
  }

  .info-window {
    width: 100%;
    position: relative;

    .header {
      background-image: url("~@/assets/image/platform/frame/frame_medium_top.svg");
      background-size: 100%;
      background-repeat: no-repeat;
      background-position: bottom center;
      height: min(5vw, 11vh);
      top: 1px;
      position: relative;
    }

    .info-content {
      background-image: url("~@/assets/image/platform/frame/frame_medium_mid.svg");
      background-size: 100%;
      background-position: center center;
      position: relative;
      padding: 25px 50px;

    }

    .footer {
      background-image: url("~@/assets/image/platform/frame/frame_medium_bot.svg");
      background-size: 100%;
      background-repeat: no-repeat;
      background-position: top center;
      height: min(5vw, 11vh);
    }

  }

  .close-button {
    width: 50px;
    height: 50px;
    position: absolute;
    right: -2%;
    top: -2%;
    background-image: url("~@/assets/image/button/bb_button_close.svg");
    background-size: contain;
    z-index: 1;
  }

  .title {
    font-size: 2rem;
    font-weight: bold;
    color: white;
    text-align: center;
    margin-top: -100px;
  }

  .description {
    color: white;
  }

  .icon {
    width: 100%;
    position: relative;
    top: -115px;
    background-position: center;
    background-repeat: no-repeat;
    height: 100px;
    background-image: $impulse-icon-outline;
  }

  .first {
    margin-bottom: 15px;
  }

  .bounce-enter-active {
    animation: bounce-in .5s;
  }

  .bounce-leave-active {
    animation: bounce-in .5s reverse;
  }

  @keyframes bounce-in {
    0% {
      transform: scale(0);
    }
    50% {
      transform: scale(1.1);
    }
    100% {
      transform: scale(1);
    }
  }

  .button-row {
    height: 15%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

</style>